<template>
    <div class="catalog-qr-list p-3">
        <div class="header-card d-flex justify-content-start align-items-top mb-4 p-3 rounded shadow-sm">
            <Backlink :back="{ name: 'catalogues.index' }" />
            <div class="border-start border-primary border-3 ps-1 ms-1">
                <h2 class="mb-1">Code QR - Catalogue</h2>
                <small class="text-muted">Partagez ce code QR avec vos clients</small>
            </div>
        </div>

        <div class="d-flex justify-content-center" ref="printPage">
            <div class="qr-card-main rounded shadow-sm p-5">
                <div class="text-center mb-4">
                    <h1>{{ tenant.name }}</h1>
                    <div class="mb-2">
                        <span class="text-muted"> {{ tenant.address }}</span> .
                        <span class="text-muted"> {{ tenant.phone }}</span> .
                        <span class="text-muted"> {{ tenant.facebook }}</span>
                    </div>
                    <!-- <h4 class="mb-2">Liste des Catalogues</h4> -->
                    <small class="text-muted">Scannez ce code QR pour accéder à tous les catalogues</small>
                </div>

                <div class="qr-container text-center mb-4">
                    <img :src="generateQRCode(getCatalogueListUrl())" alt="QR Code catalogue list"
                        class="qr-image img-fluid rounded" />
                </div>

                <div class="d-flex gap-2 flex-wrap justify-content-center mb-3">
                    <button class="btn btn-outline-purple" @click="downloadQR">
                        <i class="bi bi-download me-1"></i>Télécharger
                    </button>
                    <button class="btn btn-outline-purple" @click="printQR">
                        <i class="bi bi-printer me-1"></i>Imprimer
                    </button>
                    <button class="btn btn-outline-purple" @click="copyLink(getCatalogueListUrl())">
                        <i class="bi bi-link-45deg me-1"></i>Copier lien
                    </button>
                </div>

                <div class="text-center pt-3 border-top">
                    <small class="text-muted d-block text-break">
                        <strong>Lien:</strong><br />
                        {{ getCatalogueListUrl() }}
                    </small>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Backlink from '@/components/partials/Backlink.vue';
import { useUserStore } from '@/store/userStore';
export default {
    name: 'CatalogQr',
    components: { Backlink },
    data() {
        return {
            catalogues: [],
            link: '/catalogs'
        };
    },
    computed: {
        userStore() {
            return useUserStore();
        },
        tenant() {
            return this.userStore.$state.tenant;
        }
    },
    methods: {
        getCatalogueListUrl() {
            const baseUrl = window.location.origin;
            return `${baseUrl}/catalogues_for_clients/${this.userStore.$state.tenant.crypted_id}`;
        },
        generateQRCode(text) {
            // Using QR Server API (no installation needed)
            const encodedText = encodeURIComponent(text);
            return `https://api.qrserver.com/v1/create-qr-code/?size=400x400&data=${encodedText}`;
        },
        downloadQR() {
            const url = this.generateQRCode(this.getCatalogueListUrl());
            const link = document.createElement('a');
            link.href = url;
            link.download = 'QR-Catalogues.png';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        printQR() {
            const printWindow = window.open('', '', 'width=600,height=700');
            const qrUrl = this.generateQRCode(this.getCatalogueListUrl());
            const printPage = `
                <html>
                <head>
                    <title>QR Code - Catalogues - ${this.tenant.name}</title>
                    <style>
                        body { font-family: Arial, sans-serif; padding: 20px; text-align: center; }
                        h1 { margin-bottom: 10px; }
                        img { max-width: 450px; margin: 20px 0; }
                        p { color: #666; font-size: 12px; word-break: break-all; }
                        .info-container {
                            border: solid 2px #6a4aa6;
                            border-radius: 25px;
                            padding: 5px;
                            height: 80%;
                            display:flex;
                            justify-content: center;
                            flex-direction: column;
                        }
                        .qr-card-main {
                            border: 2px solid rgba(106, 74, 166, 0.25);
                            background: #ffffff;
                            box-shadow: 0 12px 36px rgba(106, 74, 166, 0.12);
                            max-width: 500px;
                            width: 100%;
                        }

                        .qr-container {
                            background-color: #f8f7fc;
                            padding: 20px;
                            width:70%;
                            border-radius: 12px;
                            border: 1px solid rgba(106, 74, 166, 0.15);
                            margin:auto
                        }

                        .qr-image {
                            max-width: 90%;
                            border: 3px solid #fff;
                            border-radius:10px;
                        }

                        .atelier-details-text {
                            color: #5f69e9
                        }
                        .social-box {
                            box-shadow : 2px;
                            margin : 2px;
                            padding: 2px; 
                            display:flex;
                            align-items:center;
                        }
                        .social-box img {
                            margin:3px;
                        }
                        .icon {
                            // display: inline-block;
                            width: 17px;
                            height: 17px;
                            overflow: hidden;
                        }
                    </style>
                </head>
                <body>
                    <div>
                        <div class="info-container">
                            <h1>${this.tenant.name}</h1>
                            <span class="atelier-details-text">${this.tenant.address}</span> . 
                            <span class="atelier-details-text">${this.tenant.phone}</span> . 
                            <span class="atelier-details-text">${this.tenant.facebook}</span>
                            <br/>
                            <p>Scannez ce code QR pour accéder au catalogue</p>
                            <div class="qr-container">
                                <img class="qr-image" src="${qrUrl}" alt="QR Code"/>
                            </div>
                            <div style="display:flex; justify-content:center; align-items:center;">
                                <div class="social-box">
                                    <img class="icon" src="${require('@/assets/images/icons/browser.png')}"/>
                                    <span>${this.tenant.website}</span>
                                </div>
                                <div class="social-box">
                                    <img class="icon" src="${require('@/assets/images/icons/facebook.png')}"/>
                                    <span>${this.tenant.facebook}</span>
                                </div>
                            </div>
                            
                        </div>
                        <div style="display:flex; justify-content:center; align-items:center;">
                            <span>Vous êtes couturier? Télécharger <strong>Dressmaker</strong></span>
                            <img class="icon" src="${require('@/assets/images/icons/facebook.png')}"/>
                            <strong>Pan0'pli</strong>
                        </div>
                    </div>
                </body>
                </html>
            `;

            printWindow.document.write(printPage);
            printWindow.document.close();
            printWindow.print();
        },
        copyLink(link) {
            navigator.clipboard.writeText(link).then(() => {
                this.$swal.fire('Succès', 'Lien copié dans le presse-papiers !', 'success');
            }).catch(err => {
                console.error('Erreur lors de la copie:', err);
                this.$swal.fire('Erreur', 'Erreur lors de la copie du lien.', 'error');
            });
        }
    },
    mounted() {
        // No need to fetch catalogues anymore
    }
};
</script>

<style scoped>
.catalog-qr-list {
    background: linear-gradient(130deg, #f8f2ff 0%, #fff 60%);
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.header-card {
    width: 100%;
    max-width: 600px;
    background-color: rgba(106, 74, 166, 0.12);
    border: 1px solid rgba(106, 74, 166, 0.3);
}

.qr-card-main {
    border: 2px solid rgba(106, 74, 166, 0.25);
    background: #ffffff;
    box-shadow: 0 12px 36px rgba(106, 74, 166, 0.12);
    max-width: 500px;
    width: 100%;
}

.qr-container {
    background-color: #f8f7fc;
    padding: 20px;
    border-radius: 12px;
    border: 1px solid rgba(106, 74, 166, 0.15);
}

.qr-image {
    max-width: 90%;
    border: 3px solid #fff;
}

.btn-outline-purple {
    color: #6a4aa6;
    border-color: #6a4aa6;
}

.btn-outline-purple:hover {
    color: #fff;
    background-color: #6a4aa6;
    border-color: #6a4aa6;
}
</style>
